import { RootState } from '@/store/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectWidgetDomainsList = (state: RootState): string[] => state.widgetDomainsList.data;

export const selectAllowDomains = createSelector(
	[selectWidgetDomainsList],
	(domainsList) => domainsList
);

export const selectErrorDomainsList = createSelector(
	[(state: RootState) => state.widgetDomainsList.error],
	(error) => error
);

export const selectIsFetchingDomainsList = createSelector(
	[(state: RootState) => state.widgetDomainsList.isFetching],
	(isFetching) => isFetching
);

export const selectIsNetworkError = createSelector(
	[(state: RootState) => state.widgetDomainsList.isNetworkError],
	(isNetworkError) => isNetworkError
);
